import React, { useEffect  } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Accueil = ({ timeline }) => {
  useEffect(() => {
    timeline.to(".me", {
      y: "0",
      duration: 1,
      delay:-1,
    });
  }, []);

  return (
    <Header id="accueil">
      <ContainerText className="me">
        <Title>Vasco Barreiros</Title>
        <SubTitle>Développeur FullStack</SubTitle>
      </ContainerText>
    </Header>
  );
};

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
  color: #000000;
  overflow: hidden;
 
`;

const ContainerText = styled.div`
  flex-direction: column;
  transform: translateY(500%);
`;

const Title = styled.h1`
  display: inline-block;
  font-family: "Kaushan Script", sans-serif;
  position: relative;
  font-weight: 400;
  font-size: ${(props) => props.theme.fontbig};
  transition: transform 0.2s;
  color: rgb(50, 50, 50);
  text-align: center;

  @media (max-width: 64em) {
    font-size: ${(props) => props.theme.fontxxxl};
  }

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontxlB};
  }
  @media (max-width: 30em) {
    font-size: ${(props) => props.theme.fontxl};
  }
`;

const SubTitle = styled.p`
  font-family: "Avenir Heavy", sans-serif;
  font-size: ${(props) => props.theme.fontxlB};
  letter-spacing: 0.1px;
  text-transform: uppercase;
  text-align: center;
  color: ${(props) => props.theme.grey};
  width: 80vw;

  @media (max-width: 64em) {
    font-size: ${(props) => props.theme.fontxxl};
  }

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 30em) {
    font-size: ${(props) => props.theme.fontlgB};
  }
`;

export default Accueil;
